// src/pages/AgendaLoginPage.js
import React, { useState, useEffect } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useAgendaAuth } from '../context/AgendaAuthContext.js';

export default function AgendaLoginPage() {
  const navigate = useNavigate();
  const { login, isAuthenticated, loading: authLoading } = useAgendaAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/agenda');
    }
  }, [isAuthenticated, navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.email || !formData.password) {
      setError('Email e senha sao obrigatorios');
      return;
    }

    setLoading(true);

    const result = await login(formData.email, formData.password);

    setLoading(false);

    if (result.success) {
      navigate('/agenda');
    } else {
      setError(result.error || 'Falha no login');
    }
  };

  // Show loading while checking auth
  if (authLoading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}>
        <div className="spinner-border text-light" role="status">
          <span className="visually-hidden">Carregando...</span>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
      display: 'flex',
      alignItems: 'center',
      padding: '20px'
    }}>
      <Container style={{ maxWidth: '400px' }}>
        <Card style={{ borderRadius: '15px', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }}>
          <Card.Body style={{ padding: '40px' }}>
            {/* Logo */}
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
              <h1 style={{
                fontSize: '28px',
                fontWeight: '700',
                background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                marginBottom: '10px'
              }}>
                Agenda Pessoal
              </h1>
              <p style={{ color: '#666', fontSize: '14px' }}>
                It's So Clean
              </p>
            </div>

            <h4 style={{ textAlign: 'center', marginBottom: '25px', color: '#333' }}>
              Login
            </h4>

            {error && <Alert variant="danger">{error}</Alert>}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{ padding: '12px', fontSize: '15px' }}
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Senha</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  style={{ padding: '12px', fontSize: '15px' }}
                />
              </Form.Group>

              <Button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '14px',
                  fontSize: '16px',
                  fontWeight: '600',
                  background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                  border: 'none',
                  borderRadius: '8px'
                }}
              >
                {loading ? 'Entrando...' : 'Entrar'}
              </Button>
            </Form>

            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <p style={{ color: '#666', fontSize: '14px' }}>
                Precisa de uma conta? Entre em contato com o administrador para receber um convite.
              </p>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}
